import Tag from "../../../common/UI/Tag";
import { FormState } from "../types";

export default function CertPreviewPanel({ form }: { form: FormState }) {
    const statusMap = {
        active: { color: "#6ddc6d", label: "Active" },
        expired: { color: "#e05252", label: "Expired" },
        pending: { color: "#f5a623", label: "Pending" },
    };
    const s = statusMap[form.status];
    const hasContent = form.title || form.issuedBy;

    return (
        <div style={{ background: "var(--card)", border: "1px solid var(--border)", borderRadius: 14, overflow: "hidden" }}>
            <div style={{
                display: "flex", alignItems: "center", gap: 10, padding: "14px 20px",
                borderBottom: "1px solid var(--border)", background: "var(--section-header)",
            }}>
                <span style={{ fontSize: 14, fontWeight: 600, color: "var(--text)", flex: 1 }}>Card Preview</span>
                <Tag>Live</Tag>
            </div>
            <div style={{ padding: 16 }}>
                {hasContent ? (
                    <div style={{
                        background: "var(--input-bg)", border: "1px solid var(--border)",
                        borderRadius: 12, overflow: "hidden",
                    }}>
                        {/* Image area */}
                        <div style={{
                            height: 110, background: "rgba(255,255,255,0.03)",
                            display: "flex", alignItems: "center", justifyContent: "center",
                            borderBottom: "1px solid var(--border)", overflow: "hidden",
                        }}>
                            {form.imagePreview ? (
                                <img src={form.imagePreview} alt="" style={{ maxHeight: 90, maxWidth: "100%", objectFit: "contain", padding: 8 }} />
                            ) : (
                                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 6 }}>
                                    <svg width="28" height="28" viewBox="0 0 24 24" fill="none"
                                        stroke="var(--text3)" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
                                        <rect x="3" y="3" width="18" height="18" rx="2" /><circle cx="8.5" cy="8.5" r="1.5" />
                                        <polyline points="21 15 16 10 5 21" />
                                    </svg>
                                    <span style={{ fontSize: 11, color: "var(--text3)" }}>No image uploaded</span>
                                </div>
                            )}
                        </div>
                        {/* Content */}
                        <div style={{ padding: "12px 14px" }}>
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 6 }}>
                                <span style={{
                                    fontSize: 10, fontWeight: 700, letterSpacing: "1px",
                                    textTransform: "uppercase", color: s.color,
                                    background: `${s.color}18`, border: `1px solid ${s.color}44`,
                                    borderRadius: 20, padding: "2px 7px",
                                    display: "flex", alignItems: "center", gap: 4,
                                }}>
                                    <span style={{ width: 4, height: 4, borderRadius: "50%", background: s.color, display: "inline-block" }} />
                                    {s.label}
                                </span>
                            </div>
                            <div style={{ fontSize: 14, fontWeight: 600, color: "var(--text)", marginBottom: 4, lineHeight: 1.3 }}>
                                {form.title || "Certification Title"}
                            </div>
                            {form.issuedBy && (
                                <div style={{ fontSize: 12, color: "var(--text3)" }}>by {form.issuedBy}</div>
                            )}
                            {form.expiryDate && (
                                <div style={{ fontSize: 11, color: "var(--text3)", marginTop: 6 }}>
                                    Expires {new Date(form.expiryDate).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" })}
                                </div>
                            )}
                        </div>
                    </div>
                ) : (
                    <div style={{ textAlign: "center", padding: "24px 0", color: "var(--text3)", fontSize: 13 }}>
                        Fill in the fields to see a live card preview
                    </div>
                )}
            </div>
        </div>
    );
}
